/* globals $ App */

import { Collapsible } from "./collapsible";

class countryPopup {
  constructor(languagePopup) {
    this.languagePopup = languagePopup;
    this.$elem = $("#country-popup");
    new Collapsible(this.$elem);
    this.$open = $(".js-open-country-popup");
    this.$close = this.$elem.find(".js-close");
    this.$links = this.$elem.find(".js-open-lang-popup");
    this.init();
  }

  init() {
    this.$links.click((e) => {
      e.preventDefault();
      this.languagePopup.loadLanguages($(e.target).data("id")).done(() => {
        this.closePopup(false);
      });
    });
    this.$open.click((e) => {
      e.preventDefault();
      e.stopPropagation();
      this.openPopup();
    });

    this.$close.click((e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closePopup();
    });

    this.$elem.find(".content").click((e) => {
      e.stopPropagation();
    });

    $(document).on("keydown", (e) => {
      if (e.key == "Escape") {
        this.closePopup();
      }
    });
  }

  openPopup() {
    this.$elem.fadeIn("fast");
    App.disableBodyScroll();
  }

  closePopup(enableBodyScroll = true) {
    this.$elem.fadeOut("fast");
    if (enableBodyScroll && !$("#mob-menu").is(":visible")) {
      App.enableBodyScroll();
    }
  }
}

export { countryPopup };
